import { Flex, Text } from '@chakra-ui/react';

interface BottomNavButtonProps {
  icon: React.ElementType;
  label: string;
  isActive?: boolean;
  onClick: () => void;
  ariaLabel?: string;
}

export default function BottomNavButton({
  icon: Icon,
  label,
  isActive,
  onClick,
  ariaLabel,
}: BottomNavButtonProps) {
  return (
    <Flex
      role="button"
      direction="column"
      align="center"
      justify="center"
      flex={1}
      py={2}
      cursor="pointer"
      onClick={onClick}
      aria-label={ariaLabel}
      color={isActive ? 'accent.secondary' : 'text.muted'}
      _hover={{
        color: isActive ? 'accent.secondaryHover' : 'text.primary',
        bg: 'bg.muted',
      }}
      transition="all 0.2s ease"
    >
      <Icon size={24} />
      <Text fontSize="xs" fontWeight={isActive ? '600' : '500'} mt={1}>
        {label}
      </Text>
    </Flex>
  );
}
